import React, { useCallback, useEffect, useState } from "react";
import EmailsHistory from "../../../../Common/AutoSuggestion/Email-History-Page/EmailsHistory";
import mailIcon from "../../../../Assets/Images/email-can-icon.svg";
import {
  VYLABS_BASE_URL,
  EMAIL_HISTORY_CANDIDATE,
} from "../../../../helper/url_helper.js";
import { post } from "../../../../helper/Api_helper.js";

const EMAIL_HISTORY_LIMIT = 20;

function CandidateEmailHistory({ candidate, onHasEmailHistoryChange }) {
  const [emailHistory, setEmailHistory] = useState([]);
  const [totalLogs, setTotalLogs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const candidateId = candidate?.id || candidate?.candidate_id;

  const fetchEmailHistoryData = useCallback(async () => {
    if (!candidateId) {
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        candidate_id: candidateId,
        offset: 0,
        limit: EMAIL_HISTORY_LIMIT,
      };
      const emailHistoryResponse = await post(
        VYLABS_BASE_URL,
        EMAIL_HISTORY_CANDIDATE,
        payload,
      );
      const emailLogs = Array.isArray(emailHistoryResponse?.email_logs)
        ? emailHistoryResponse.email_logs
        : [];

      setEmailHistory(emailLogs);
      setTotalLogs(
        typeof emailHistoryResponse?.total_logs === "number"
          ? emailHistoryResponse.total_logs
          : emailLogs.length,
      );
      onHasEmailHistoryChange?.(emailLogs.length > 0);
    } catch (error) {
      console.error("Error fetching candidate email history:", error);
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
    } finally {
      setIsLoading(false);
    }
  }, [candidateId, onHasEmailHistoryChange]);

  useEffect(() => {
    fetchEmailHistoryData();
  }, [fetchEmailHistoryData]);

  return (
    <EmailsHistory
      emailHistory={emailHistory}
      totalLogs={totalLogs}
      isLoading={isLoading}
      entityLabel="candidate"
      mailIcon={mailIcon}
      defaultVariant="candidate"
    />
  );
}

export default CandidateEmailHistory;
